import { useGate } from 'statsig-react';

import useBundleGate from '@/app/experiments/bundle/useBundleGate';

interface UseBundle {
  bundleInternational: boolean;
  bundleUs: boolean;
  bundleEnabled: boolean;
  isMobile: boolean;
  isRounded: boolean;
}

// TODO: GROW-1620 Productize Bundle
const useBundle = (): UseBundle => {
  const { bundleEnabled, bundleUs, bundleInternational } = useBundleGate();
  const isMobile = useGate('ismobile').value;

  return {
    bundleInternational,
    bundleUs,
    bundleEnabled,
    isMobile,
    isRounded: !isMobile,
  };
};
export default useBundle;
